import Api from '../../api/index'
import idb_exec from "../../idb/executions";
import idb_di from "../../idb/done_items";
import transform_photo_compressed_to_signed_ids from '../../utils/transform_photo_compressed_to_direct_upload';
import transform_signature_to_signed_id from '../../utils/transform_signature_to_direct_upload';

const Execution = {
  namespaced: true,
  state: {
    value: 'my value',

    oneDoneForm: null, //to store SHOW response
    allDoneForms: null, //to store SHOW response

    saving_exec: false,
    saving_item: false,

    oneExecution: {},
    question: 0,
    default_action_plan: {
      info: {
        what: null,
        why: null,
        where: null,
        when: null,
        who: null,
        how: null,
        how_much: null,
        from: null
      },
      receiver_ids: null,
      form_id: null,
      item_id: null,
      emitter_id: null,
      solution_id: null,
      dead_line: null
    },
    oneItem: {},

  },
  getters: {
    getExecution: state => {
      return state.oneExecution;
    },
    getDefaultActionPlan: state => {
      let {info, receiver_ids, form_id, item_id, emitter_id, solution_id, dead_line} = state.default_action_plan
      return {info, receiver_ids, form_id, item_id, emitter_id, solution_id, dead_line};
    }
  },

  mutations: {
    setSavingExec(state, data){
      state.saving_exec = data
    },
    setSavingItem(state, data){
      state.saving_item = data
    },

    repeatQuestion(state, {idx, ndi}){
      state.oneExecution.done_items.splice(idx+1, 0, {...ndi})
    },


    setOneDoneForm(state, DoneForm){
      state.oneDoneForm = DoneForm // DoneForm.data
    },
    setAllDoneForms(state, DoneForms){
      state.allDoneForms = DoneForms // DoneForms.data
    },

    setOneExecution(state, data){
      state.oneExecution = data
      let q = data.done_items.map(d=>d.answer).indexOf(null)
      state.question = q > -1? q : data.done_items.length-1
    },
    resetExecution(state, data){
      state.oneExecution = {
        ...state.oneExecution,
        ...data,
      }
    },

    questionAdd(state){
      state.question++
    },
    questionRemove(state){
      state.question--
    },
    setQuestion(state, val){
      state.question = val
    },


    setExtraEmails(state, data){
      state.oneExecution = {
        ...state.oneExecution,
        extra_emails: data
      }
    },

    updateDoneItem(state, data){
      let di_idx = state.oneExecution.done_items.findIndex(di=> di.item_setup_id == data.item_setup_id && di.repetitions == data.repetitions)
      let done_items = state.oneExecution.done_items//.splice(di_idx, 1, data)
      done_items.splice(di_idx, 1, data)
      // debugger
      state.oneExecution = {
        ...state.oneExecution,
        done_items
      }
    },
    

    clearAllDoneForms(state){
      state.allDoneForms = null
    },
    clearOneDoneForm(state){
      state.oneDoneForm = null
    },
    clearExecution(state){
      state.oneExecution = {}
    },
    setDepartmentId(state, id){
      state.oneExecution.department_id = id
    },
  },

  actions: {
    clearAllDoneForms({commit}){
      commit('clearAllDoneForms')
    },
    clearOneDoneForm({commit}){
      commit('clearOneDoneForm')
    },

    clearExecution({commit}){
      commit('clearExecution')
    },
    
    sendSuccessNotification({dispatch}, msg){
      let notification = {
        type: 'success',
        msg: `${msg}`
      }
      dispatch('Notification/add', notification, {root: true})
    },
    sendErrorNotification({dispatch}, msg){
      let notification = {
        type: 'error',
        msg: `Erro: ${msg}`
      }
      dispatch('Notification/add', notification, {root: true})
    },

    async setOneExecution({commit, getters}, form){
      let is_new = form.idb_id == null || form.idb_id == undefined
      const new_idb_id = form.id || form.idb_id || Math.random()
      const {done_items, ...f} = form
      const exec = {
        ...f,
        idb_id: new_idb_id,
        state: 'in_process',
        started_at: new Date(f.started_at).toISOString()
      }
      let di = done_items
      if (is_new) {
        let idb_form = await idb_exec.store_executions(exec).then(r=>{
          // console.log('salvou o new-form');
          // context.dispatch('CustomField/index', null, {root: true})
        })
        // console.log({idb_form});
  
        di = done_items.map(d=> { return { ...d, execution_idb_id: new_idb_id, idb_id: d.id || d.idb_id || Math.random()} })
        let idb_done_items = await idb_di.store_done_items(di).then(r=>{
          // console.log('salvou os done-items');
        })
      }
      // console.log({idb_done_items});

      commit('setOneExecution', {...f, idb_id: new_idb_id, done_items: [...di]})
      return getters.getExecution
    },

    addItemAnswered(){

    },

    show(context, id) {
      const MODULE = true? 'DoneForm' : 'GhostExecution'
      Api[MODULE].show(id)
        .then(response => response.data)
        .then(DoneForm => {
          // context.dispatch('sendSuccessNotification', 'Encontrado com sucesso')
          context.commit("setOneDoneForm", DoneForm);
        }).catch(function(error) {
          console.log(error);
          context.dispatch('sendErrorNotification', error.response.data.errors[0])
        });
    },
    async create(context, new_df) {
      new_df = {
        ...new_df,
        // is_partial: true,
        // state: 'in_process',
        done_at: new Date()
      }
      let direct_upload_error = false
      let direct_upload_error_by_idx = {}

      for (let idx = 0; idx < new_df.done_items.length; idx++) {
        let one_done_item = new_df.done_items[idx];

        if (one_done_item.answer){
          one_done_item.done_at = new Date().toISOString()
          if (context.rootState.User.oneUser){
            one_done_item.user_id = context.rootState.User.oneUser.id
          }
        }
        
        let has_photo = one_done_item.photo_original || (one_done_item.photo_compressed != null && (typeof(one_done_item.photo_compressed) == 'object') )
        let has_signature = (one_done_item.signature_img && (typeof(one_done_item.signature_img)=='object') && one_done_item.kind == 'signature')

        // if (one_done_item.photo_original || (one_done_item.photo_compressed != null && (typeof(one_done_item.photo_compressed) == 'object') ) ){
        if ( has_photo || has_signature ){
          // fazer o direct upload se tiver foto ou assinatura, colocar a ref no DI
          // -> se der pal, somenete atualizar no banco local (catch da req da API)
          context.commit('setSavingItem', true)
          try {
            if (has_photo){
              let pc_signeds = await transform_photo_compressed_to_signed_ids(one_done_item.photo_compressed)
              // console.log({pc_signeds});
              one_done_item.photo_compressed = pc_signeds
            }
            if (has_signature){
              let sig_signeds = await transform_signature_to_signed_id(one_done_item.signature_img)
              // console.log({sig_signeds});
              one_done_item.signature_img = sig_signeds
            }
          } catch (error) {
            console.log({error});
            direct_upload_error = true
            direct_upload_error_by_idx[idx] = true
          }
        }
        
      }
      context.commit('setSavingItem', false)

      console.log({direct_upload_error, direct_upload_error_by_idx});
      // iterar em cada done-item, fazer o direct upload se tiver foto ou assinatura, colocar a ref no DI
      // -> se der pal, somenete atualizar no banco local (catch da req da API)

      context.commit('setSavingExec', true)

      const MODULE = new_df.user_id? 'DoneForm' : 'GhostExecution'
      return Api[MODULE].create(new_df).then(response => response.data).then( async DoneForm => {
        
        // ---- dentro da action, se criação ok, atualizar todos os dados do idb
        try {
          let {done_items, ...df} = DoneForm
          let done_items_attributes = new_df.done_items
          delete new_df.done_items
          let {form_id, ...ndf} = new_df

          df = {
            ...ndf,
            ...df,
            with_error_api: direct_upload_error || false,
          }
          
          if (new_df.state != 'concluded'){

            // console.log('gonna call update one exec on idb', {...df}, {idb_id: df.id}, {idbid: ndf.idb_id});

            // await idb_exec.update_one_execution(df)
            await idb_exec.delete_executions( 'idb_id' , ndf.idb_id)
            await idb_exec.update_one_execution({...df, idb_id: df.id})
            
            await idb_di.delete_done_items( 'execution_idb_id' , ndf.idb_id )
  
            done_items = done_items.data? done_items.data.map(di=> di.attributes) : done_items
            // debugger
            let dis = []
            let di = {}
            for (let idx = 0; idx < done_items.length; idx++) {
              di = {
                ...done_items_attributes.find(d=> d.item_setup_id == done_items[idx].item_setup_id),
                ...done_items[idx],
                error_api: direct_upload_error_by_idx[idx] || false, 
                answer_changed: direct_upload_error_by_idx[idx] || false,
                photo_original: null,
                idb_id: done_items[idx].id,
                execution_idb_id: df.id,
                
              }
              dis.push(di)
  
              // console.log('gonna call update one done-item on idb', {di});
              // debugger
              await idb_di.update_one_done_item(di)
              // debugger
            }
  
            let exec = {
              ...df,
              done_items: [...dis]
            }

            context.commit('resetExecution', exec)
            context.commit('setSavingExec', false)

          } else if (new_df.state == 'concluded'){
            await idb_di.delete_done_items( 'execution_idb_id' , ndf.idb_id )
            await idb_exec.delete_executions( 'idb_id' , ndf.idb_id )
            context.dispatch('sendSuccessNotification', 'Criado com sucesso')
            context.commit('setSavingExec', false)
            context.commit('clearExecution')
          }
          context.commit('setSavingExec', false)
        } catch (error) {
          console.error({error});
          context.commit('setSavingExec', false)
          throw error
        }
        // ---- dentro da action, se criação ok, apos atualizar todos os dados do idb, atualizar vuex
      }).catch( async function(error) {
        console.log(error);
        await idb_exec.update_one_execution({...new_df, with_error_api: true})
        if (new_df.state == 'concluded'){
          context.commit('clearExecution') //-> // ! TESTAR
        }
        context.commit('setSavingExec', false)

        // SEM MSG DE ERRO PARA NAO INCOMODAR USER
        // context.dispatch('sendErrorNotification', error)
        throw error
      });
    },
    async update(context, execution) {
      execution = {
        ...execution,
        is_partial: false,
        state: execution.state == 'to_approve' || execution.approval_ids ? 'to_approve' : 'concluded',
        done_at: new Date()
      }
      let direct_upload_error = false
      let direct_upload_error_by_idx = {}

      if (execution.done_items && execution.done_items.length){
        for (let idx = 0; idx < execution.done_items.length; idx++) {
          let one_done_item = execution.done_items[idx];

          if (one_done_item.action_plan) {
            delete one_done_item.action_plan_attributes;
          }

          if (one_done_item.answer && one_done_item.answer_changed){
            one_done_item.done_at = new Date().toISOString()
            if (context.rootState.User.oneUser){
              one_done_item.user_id = context.rootState.User.oneUser.id
            }
          }
          
          let has_photo = one_done_item.photo_original || (one_done_item.photo_compressed != null && (typeof(one_done_item.photo_compressed) == 'object') )
          let has_signature = (one_done_item.signature_img && (typeof(one_done_item.signature_img)=='object') && one_done_item.kind == 'signature')
  
          // if (one_done_item.photo_original || (one_done_item.photo_compressed != null && (typeof(one_done_item.photo_compressed) == 'object') ) ){
          if ( has_photo || has_signature ){
            // fazer o direct upload se tiver foto ou assinatura, colocar a ref no DI
            // -> se der pal, somenete atualizar no banco local (catch da req da API)
            context.commit('setSavingItem', true)
            try {
              if (has_photo){
                let pc_signeds = await transform_photo_compressed_to_signed_ids(one_done_item.photo_compressed)
                // console.log({pc_signeds});
                one_done_item.photo_compressed = pc_signeds
              }
              if (has_signature){
                let sig_signeds = await transform_signature_to_signed_id(one_done_item.signature_img)
                // console.log({sig_signeds});
                one_done_item.signature_img = sig_signeds
              }
            } catch (error) {
              console.log({error});
              direct_upload_error = true
              direct_upload_error_by_idx[idx] = true
            }
          }
          
        }
      }
      context.commit('setSavingItem', false)

      // console.log({direct_upload_error, direct_upload_error_by_idx});

      context.commit('setSavingExec', true)

      const MODULE = execution.user_id? 'DoneForm' : 'GhostExecution'
      return Api[MODULE].update(execution).then(response => response.data).then( async exec => {
        try {
          if (!direct_upload_error){
            await idb_di.delete_done_items( 'execution_idb_id' , execution.id )
            await idb_exec.delete_executions( 'idb_id' , execution.id)
            context.commit('clearExecution')
            context.commit('setSavingExec', false)
          } else {
            throw new Error(`Error in direct_upload => ${Object.keys(direct_upload_error_by_idx).join('--')}`)
          }
        } catch (error) {
          console.error({error});
          throw error
        }
        context.dispatch('sendSuccessNotification', 'Concluído com sucesso')
      }).catch(async function(error) {
        console.log(error);
        await idb_exec.update_one_execution({...execution, with_error_api: true})
        context.commit('clearExecution')
        context.dispatch('sendErrorNotification', error)
        context.commit('setSavingExec', false)
        throw error
      });
    },

    async cancelExecution(context, execution){
      let no_answer = !execution.done_items.filter(di => !!di.answer).length
      let no_error_api = !execution.done_items.filter(di => !!di.error_api).length && !execution.with_error_api
      let no_answer_changed = !execution.done_items.filter(di => !!di.answer_changed).length
      let answer_changed = execution.done_items.filter(di => !!di.answer_changed).length

      // console.log({no_answer}, {no_error_api}, {no_answer_changed});
      if (execution.exec_kind == 'steps' || execution.form_exec_kind == 'steps'){
        // debugger
        if ((no_answer || no_error_api) && !answer_changed){
          // alert('nao tem nenhuma resposta ou nao houve nenhum erro da api, pode apagar do idb')
          // nao tem nenhuma resposta, pode apagar do idb
          // let done_items_idb_ids = execution.done_items.map(di => di.idb_id)
          try {
            await idb_di.delete_done_items( 'execution_idb_id' , execution.idb_id )
    
            await idb_exec.delete_executions( 'idb_id' , execution.idb_id)
            
          } catch (error) {
            console.error(error);
          }
        } else {
          let errors = ''
          let msg = 'Você possui respostas sem salvar, para continuar, visite a sessão de "Realizações Parcias" para retomar a execução'
          alert(msg)
        }
      } else {
        // exec-kind é instant e nao permit salvar as resposas no idb se fechar
        alert('Suas respostas não foram foram salvas')
        // let done_items_idb_ids = execution.done_items.map(di => di.idb_id)
        try {
          await idb_di.delete_done_items( 'execution_idb_id' , execution.idb_id )
  
          await idb_exec.delete_executions( 'idb_id' , execution.idb_id)
          
        } catch (error) {
          console.error(error);
        }
      }
    },

    async repeatQuestion(context, data){
      let {one_item, idx} = data
      let {id, answer, answer_changed, idb_id, repetitions, action_plan_attributes, action_plan, ...d} = one_item // context.state.oneExecution.done_items[idx]
      repetitions = repetitions? (Number(repetitions) +1) : 1
      let ndi = Object.assign({}, d)
      ndi = {
        ...ndi,
        idb_id: Math.random(),
        repetitions,
        answer_changed: false,
        not_applied: false,
        photo_compressed: null,
        signature_img: null,
        photo_original: null,
        custom_value_id: null,
        comment: null,
        succeeded: true,
        answer: null,
      }
      if (ndi.action_plan_attributes){
        ndi.action_plan_attributes = null
      }
      if (ndi.sub_items && ndi.sub_items.length){
        ndi = {
          ...ndi,
          sub_items: {
            sub_items: [...ndi.sub_items]
          }
        }
      }
      await idb_di.store_done_items([ndi])
      if(ndi.done_form_id){
        ndi = { 
          ...ndi, 
          ...await context.dispatch('createDoneItem', {...ndi})
        }
      }
      context.commit('repeatQuestion', {idx, ndi})
      // context.state.oneExecution.done_items.splice(idx+1, 0, {...ndi})
    },

    async createDoneItem(context, done_item){
      let direct_upload_error = false
      let has_photo = done_item.photo_original || (done_item.photo_compressed != null && (typeof(done_item.photo_compressed) == 'object') )
      let has_signature = (done_item.signature_img && (typeof(done_item.signature_img)=='object') && done_item.kind == 'signature')

      // if (done_item.photo_original || (done_item.photo_compressed != null && (typeof(done_item.photo_compressed) == 'object') ) ){
      if ( has_photo || has_signature ){
        // fazer o direct upload se tiver foto ou assinatura, colocar a ref no DI
        // -> se der pal, somenete atualizar no banco local (catch da req da API)
        context.commit('setSavingItem', true)
        try {
          if (has_photo){
            let pc_signeds = await transform_photo_compressed_to_signed_ids(done_item.photo_compressed)
            // console.log({pc_signeds});
            done_item.photo_compressed = pc_signeds
          }
          if (has_signature){
            let sig_signeds = await transform_signature_to_signed_id(done_item.signature_img)
            // console.log({sig_signeds});
            done_item.signature_img = sig_signeds
          }
        } catch (error) {
          console.log({error});
          direct_upload_error = true
        }
      }

      // console.log({direct_upload_error});

      let updated_done_item = {}
      const MODULE = !localStorage.ghost_tk? 'DoneItem' : 'GhostExecutionItem'
      return await Api[MODULE].create(done_item).then(r=>r.data).then(async up_done_item=> {
        // -- deu certo -> apaga o antigo & update_one_di dnv com o id 
        updated_done_item = {
          ...done_item,
          ...up_done_item,
          error_api: direct_upload_error || false,
          answer_changed: direct_upload_error || false,
          photo_original: null
        }
        await idb_di.update_one_done_item(updated_done_item)
        return updated_done_item
      }).catch(async err=>{
        // -- deu erro -> update_one_di dnv com o error_api: true
        updated_done_item = {...done_item, error_api: true, answer_changed: true}
        await idb_di.update_one_done_item(updated_done_item)
      }).finally(()=>{
        context.commit('setSavingItem', false)
      })
    },

    
    async updateDoneItem(context, done_item){
      let direct_upload_error = false
      let has_photo = done_item.photo_original || (done_item.photo_compressed != null && (typeof(done_item.photo_compressed) == 'object') )
      let has_signature = (done_item.signature_img && (typeof(done_item.signature_img)=='object') && done_item.kind == 'signature')

      done_item.done_at = new Date().toISOString()
      done_item.user_id = context.rootState.User.oneUser.id

      // if (done_item.photo_original || (done_item.photo_compressed != null && (typeof(done_item.photo_compressed) == 'object') ) ){
      if ( has_photo || has_signature ){
        // fazer o direct upload se tiver foto ou assinatura, colocar a ref no DI
        // -> se der pal, somenete atualizar no banco local (catch da req da API)
        context.commit('setSavingItem', true)
        try {
          if (has_photo){
            let pc_signeds = await transform_photo_compressed_to_signed_ids(done_item.photo_compressed)
            // console.log({pc_signeds});
            done_item.photo_compressed = pc_signeds
          }
          if (has_signature){
            let sig_signeds = await transform_signature_to_signed_id(done_item.signature_img)
            // console.log({sig_signeds});
            done_item.signature_img = sig_signeds
          }
        } catch (error) {
          console.log({error});
          direct_upload_error = true
        }
      }

      // console.log({direct_upload_error});
      
      await idb_di.update_one_done_item(done_item).then(r=> {
        // console.log({done_item_updated: r});
        let updated_done_item = {}
        // chamar API
        const MODULE = !localStorage.ghost_tk? 'DoneItem' : 'GhostExecutionItem'
        Api[MODULE].update(done_item).then(r=>r.data).then(async up_done_item=> {
          // -- deu certo -> apaga o antigo & update_one_di dnv com o id 
          updated_done_item = {
            ...done_item, 
            ...up_done_item, 
            error_api: direct_upload_error || false, 
            answer_changed: direct_upload_error || false, 
            photo_original: null, 
            photo_compressed_attachments_attributes: null
          }
          await idb_di.update_one_done_item(updated_done_item)
        }).catch(async err=>{
          // -- deu erro -> update_one_di dnv com o error_api: true
          // console.log('Error ao atualizar done-item', err);
          updated_done_item = {...done_item, error_api: true, answer_changed: true}
          await idb_di.update_one_done_item(updated_done_item)
        }).finally(()=>{
          context.commit('setSavingItem', false)
          context.commit('updateDoneItem', updated_done_item)
        })
      }).catch(err=>{
        context.commit('setSavingItem', false)
        console.error({err});
      })
    },
    

    async updateDoneItemOnlyIdb(context, done_item){
      // console.log('updating only in idb', {done_item});
      let a = await idb_di.update_one_done_item(done_item)
      // console.log({a});
      // context.commit('updateDoneItem', updated_done_item)
    }
  }

};

export default Execution;
